import PersonIconSvg from "src/components/svg/PersonIconSvg";
import NextImage from "next/image";
import styled, { css } from "src/lib/styles/css";
import theme from "src/components/themes/DefaultTheme";

//#region [Styles]
type SPortraitProps = {
	$noProfilePic?: boolean;
}

const SPortrait = styled.div<SPortraitProps>`
	box-sizing: border-box;
	width: var(--portrait-size, 75px);
	height: var(--portrait-size, 75px);
	border-radius: 50%;
	position: relative;
	overflow: hidden;
	background-color: ${theme.palette.lilla4};
	margin: 0 auto;

	${props => props.$noProfilePic && css`
		border: 2px solid ${theme.palette.turkis2};
	`}
`;

export default SPortrait;

export const SPlaceHolderPersonIconSvg = styled(PersonIconSvg)`
	width: 100%;
	height: 100%;
	fill: var(--textcolor);
`;

export const SUserImage = styled(NextImage)`
	width: 100%;
	display: block;
	margin: 0 auto;
`;
//#endregion